<div class="progress-custom">
  <mat-spinner class="progress-spinner"></mat-spinner>
  @if(spinnerText) {
    <div class="spinner-text main-text-color">{{spinnerText}}</div>
  }
</div>
